import { Component, forwardRef, Input } from '@angular/core';
import { BaseControlValueAccessor } from '../../common/base-control-value-accessor.abstract';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'gcc-textarea-input',
  templateUrl: './textarea-input.component.html',
  styleUrls: ['./textarea-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TextareaInputComponent),
      multi: true
    }
  ]
})
export class TextareaInputComponent extends BaseControlValueAccessor<string> {
  @Input() public label = 'Description text';
  @Input() public maxLength = 500;
  @Input() public isDisabled = false;

  public handleInput(event: InputEvent | Event): void {
    this.updateValue((event.target as HTMLTextAreaElement).value);
  }
}
